export default __webpack_public_path__ + "static/media/premium2.919010f9.png";